import { render, staticRenderFns } from "./CardGold.vue?vue&type=template&id=5a49212c&scoped=true&"
import script from "./CardGold.vue?vue&type=script&lang=js&"
export * from "./CardGold.vue?vue&type=script&lang=js&"
import style0 from "./CardGold.vue?vue&type=style&index=0&id=5a49212c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a49212c",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VImg } from 'vuetify/lib/components/VImg';
installComponents(component, {VCard,VImg})


/* hot reload */
if (module.hot) {
  var api = require("D:\\Trabalho\\Lupa Soluções em TI\\Clientes\\Leonardo Raton\\Site\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5a49212c')) {
      api.createRecord('5a49212c', component.options)
    } else {
      api.reload('5a49212c', component.options)
    }
    module.hot.accept("./CardGold.vue?vue&type=template&id=5a49212c&scoped=true&", function () {
      api.rerender('5a49212c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/pages/SelecaoAssinatura/components/cards/investidor/CardGold.vue"
export default component.exports